import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { validateLayerData } from './utils.js';
import { CONFIG } from './constants.js';
import { createDispatcher } from './dispatcher.js';

function createClientBroadcaster(_ref) {
  var _ref$env = _ref.env,
      env = _ref$env === void 0 ? 'dev' : _ref$env;

  var _createDispatcher = createDispatcher(CONFIG[env]),
      _createDispatcher2 = _slicedToArray(_createDispatcher, 2),
      push = _createDispatcher2[0],
      send = _createDispatcher2[1];

  return function (data) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$flush = _ref2.flush,
        flush = _ref2$flush === void 0 ? false : _ref2$flush;

    var event_data = validateLayerData(data, {
      debug: CONFIG[env].debug
    });
    push(event_data);

    if (flush) {
      send();
    }
  };
}

export { createClientBroadcaster };
